import { reactive } from "vue";

export const log = reactive({
  data: []
});
